import Nullstack from 'nullstack';
export default function IconWorldDownload({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-world-download",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 12a9 9 0 1 0 -9 9"
  }), "   ", Nullstack.element("path", {
    d: "M3.6 9h16.8"
  }), "   ", Nullstack.element("path", {
    d: "M3.6 15h8.4"
  }), "   ", Nullstack.element("path", {
    d: "M11.578 3a17 17 0 0 0 0 18"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 3c1.719 2.755 2.5 5.876 2.5 9"
  }), "   ", Nullstack.element("path", {
    d: "M18 14v7m-3 -3l3 3l3 -3"
  }), " ");
}